import Vue from 'vue'
import Router from 'vue-router'
// import {Router, createRouter, createWebHistory } from 'vue-router'
import { publicRoute, authenRoute, adminRoute } from './config'

const routes = publicRoute.concat(authenRoute.concat(adminRoute))
Vue.use(Router)
const router = new Router({ 
  mode: 'hash',
  linkActiveClass: 'active',
  routes: routes,
})

// const router = createRouter({
//   history: createWebHistory(),
//   routes
// });
// Vue.use(router) 

router.beforeEach((to, from, next) => {
  //console.log(to, from)
  const user = Vue.prototype.$auth.isAuthenticated()
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  let authorized = true
  if (requiresAuth) {
    let userRoles = Vue.prototype.$auth.getUserRoles()
    authorized = to.matched.some((e) => {
      //console.log('to.matched.some', e)
      if (e.meta.roles.length === 0) {
        return true
      } else {
        // return e.meta.roles.some((o) => {
        //   console.log('EEEEE>> ', o)
        //   return userRoles.indexOf(o) >= 0
        // })
        return userRoles.some((o) => {
          //console.log('EEEEE>> ', o)
          return e.meta.roles.indexOf(o) >= 0
        })
      }
    })
  }
  //console.log('PAGE ROUTE', !user, requiresAuth, authorized)
  if (requiresAuth && !user) {
    //console.log('Login....')
    next({
      path: '/authen/login',
      query: { redirect: '/' },
    })
    return
  }
  if (!authorized) {
    //console.log('ROUTER UNAUTHORIZED LOGIN')
    next({
      path: '/authen/unauthorized',
      query: { redirect: to.fullPath }
    })
    return
  }
  next()
})

/*router.afterEach((to, from) => {
  console.log(to, from)
})*/

export default router
